import { render, staticRenderFns } from "./approve.pgcoord.vue?vue&type=template&id=2493bf56"
import script from "./approve.pgcoord.vue?vue&type=script&lang=js"
export * from "./approve.pgcoord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports